import { createPortfolio, deletePortfolio } from '@lms/api-client/backend';
import { z } from 'zod';

// Ports app/[brand]/admin/portfolios/_components/actions.schema.ts.
export const createPortfolioSchema = z.object({
  name: z.string().min(1),
  slug: z.string().min(1),
});

export type CreatePortfolioInput = z.infer<typeof createPortfolioSchema>;

export type AddPortfolioResult =
  | { status: 'success' }
  | {
      status: 'error';
      errors: { name?: string; slug?: string; form?: string };
    };

// Ports the `addPortfolio` server action. The Next app validated with conform
// and revalidated the path; here the caller validates the returned result and
// revalidates via SWR `mutate`.
export async function addPortfolio(
  input: CreatePortfolioInput,
): Promise<AddPortfolioResult> {
  const submission = createPortfolioSchema.safeParse(input);

  if (!submission.success) {
    const fieldErrors = submission.error.flatten().fieldErrors;
    return {
      status: 'error',
      errors: {
        name: fieldErrors.name?.[0],
        slug: fieldErrors.slug?.[0],
      },
    };
  }

  const { name, slug } = submission.data;
  try {
    await createPortfolio({ name, slug });
  } catch (e) {
    return {
      status: 'error',
      errors: { form: `${e}` },
    };
  }

  return { status: 'success' };
}

// Ports the `removePortfolio` server action. The Next app caught the error and
// redirected on success; here the caller handles both (toast on failure, SWR
// `mutate` on success).
export async function removePortfolio(portfolioId: number): Promise<void> {
  await deletePortfolio(portfolioId);
}
